import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@hopskipdrive/react-components';

import { AxiosErrorBoundary } from './api/utils/AxiosErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { LaunchDarklyProvider } from './contexts/LDContext';
import { LoaderProvider } from './contexts/LoaderContext';
import { ToastProvider } from './contexts/ToastContext';
import { ErrorBoundary } from './utils/errorReporting/ErrorBoundary';
import Routes from './routes';

export const App = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <LaunchDarklyProvider>
            <AxiosErrorBoundary>
              <ThemeProvider>
                <ToastProvider>
                  <LoaderProvider>
                    <Routes />
                  </LoaderProvider>
                </ToastProvider>
              </ThemeProvider>
            </AxiosErrorBoundary>
          </LaunchDarklyProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};
